import { render, staticRenderFns } from "./TargetContactImport.vue?vue&type=template&id=c51cd7c4&scoped=true"
import script from "./TargetContactImport.vue?vue&type=script&lang=js"
export * from "./TargetContactImport.vue?vue&type=script&lang=js"
import style0 from "./TargetContactImport.vue?vue&type=style&index=0&id=c51cd7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51cd7c4",
  null
  
)

export default component.exports